import React from 'react';
import qs from 'qs';

import config from '../config';

import IconGoogle from 'icons/icon-google';
import IconZoomus from 'icons/icon-zoomus';
import IconGitHub from 'icons/icon-github';
import IconSlack from 'icons/icon-slack';

const APP_DOMAIN = config.APP_DOMAIN === 'localhost' ? 'niftyqa.com' : config.APP_DOMAIN;
const REDIRECT_URI_BASE = `https://${APP_DOMAIN}/external-redirect`;

export const EXTERNAL_ACCOUNTS_OPTIONS = [
    {
        provider: 'github',
        name: 'GitHub',
        types: ['user', 'team'],
        icon: <IconGitHub />,
        connectUrl: `https://github.com/login/oauth/authorize?${qs.stringify({
            redirect_uri: `${REDIRECT_URI_BASE}/github`,
            client_id: config.GITHUB_CLIENT_ID,
            scope: 'repo'
        })}`
    },
    {
        provider: 'google',
        name: 'Google Auth & Drive',
        icon: <IconGoogle />,
        types: ['user'],
        connectUrl: `https://accounts.google.com/o/oauth2/v2/auth?${qs.stringify({
            response_type: 'code',
            redirect_uri: `${REDIRECT_URI_BASE}/google`,
            client_id: config.GOOGLE_CONFIG.CLIENT_ID,
            access_type: 'offline',
            scope: 'https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/drive',
            nonce: 'Nifty',
            prompt: 'consent'
        })}`
    },
    {
        provider: 'googleCalendar',
        name: 'Google Calendar',
        icon: <IconGoogle />,
        types: ['user'],
        connectUrl: `https://accounts.google.com/o/oauth2/v2/auth?${qs.stringify({
            response_type: 'code',
            redirect_uri: `${REDIRECT_URI_BASE}/google`,
            client_id: config.GOOGLE_CONFIG.CLIENT_ID,
            access_type: 'offline',
            scope: 'https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/drive https://www.googleapis.com/auth/calendar.readonly https://www.googleapis.com/auth/calendar.events',
            nonce: 'Nifty',
            prompt: 'consent'
        })}`
    },
    {
        provider: 'slack',
        name: 'Slack',
        types: ['user'],
        icon: <IconSlack />,
        connectUrl: 'https://slack.com/apps/A018JHQSHRR-nifty',
        noState: true
        // connectUrl: `https://slack.com/oauth/v2/authorize?${qs.stringify({
        //     // redirect_uri: `${REDIRECT_URI_BASE}/slack`,
        //     client_id: config.SLACK_CLIENT_ID,
        //     scope: 'app_mentions:read,chat:write,workflow.steps:execute,commands'
        // })}`
    },
    {
        provider: 'zoom',
        name: 'Zoom',
        types: ['team', 'user'],
        icon: <IconZoomus />,
        connectUrl: `https://zoom.us/oauth/authorize?${qs.stringify({
            response_type: 'code',
            redirect_uri: `${REDIRECT_URI_BASE}/zoom`,
            client_id: config.ZOOM_CLIENT_ID
        })}`
    }
];

export const getExternalAccountOptions = provider => EXTERNAL_ACCOUNTS_OPTIONS.find(account => account.provider === provider);

export const getOAuthStateParam = (token, isTeam) => {
    const type = isTeam ? 'tt' : 'mt';
    return `${type}~${token}`;
}
